'use strict';

var _toArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toArray");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var debug = require('debug');

var errcode = require('err-code');

var mergeOptions = require('merge-options');

var CID = require('cids');

var isDomain = require('is-domain-name');

var log = debug('ipfs:name:resolve');
log.error = debug('ipfs:name:resolve:error');

var _require = require('../../utils'),
    OFFLINE_ERROR = _require.OFFLINE_ERROR,
    withTimeoutOption = _require.withTimeoutOption;

var appendRemainder = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(result, remainder) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return result;

          case 2:
            result = _context.sent;

            if (!remainder.length) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", result + '/' + remainder.join('/'));

          case 5:
            return _context.abrupt("return", result);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function appendRemainder(_x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * @typedef { import("../index") } IPFS
 */

/**
 * IPNS - Inter-Planetary Naming System
 *
 * @param {IPFS} self
 * @returns {Object}
 */


module.exports = function (_ref2) {
  var dns = _ref2.dns,
      ipns = _ref2.ipns,
      peerInfo = _ref2.peerInfo,
      isOnline = _ref2.isOnline,
      constructorOptions = _ref2.options;

  /**
   * Given a key, query the DHT for its best value.
   *
   * @param {String} name ipns name to resolve. Defaults to your node's peerID.
   * @param {Object} options ipfs resolve options.
   * @param {boolean} options.nocache do not use cached entries.
   * @param {boolean} options.recursive resolve until the result is not an IPNS name.
   * @param {function(Error)} [callback]
   * @returns {Promise|void}
   */
  return withTimeoutOption( /*#__PURE__*/function () {
    var _resolve = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(name, options) {
      var offline, _name$slice$split, _name$slice$split2, namespace, hash, remainder;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // eslint-disable-line require-await
              options = mergeOptions({
                nocache: false,
                recursive: true
              }, options || {});
              offline = constructorOptions.offline; // TODO: params related logic should be in the core implementation

              if (!(offline && options.nocache)) {
                _context2.next = 4;
                break;
              }

              throw errcode(new Error('cannot specify both offline and nocache'), 'ERR_NOCACHE_AND_OFFLINE');

            case 4:
              // Set node id as name for being resolved, if it is not received
              if (!name) {
                name = peerInfo.id.toB58String();
              }

              if (!name.startsWith('/ipns/')) {
                name = "/ipns/".concat(name);
              }

              _name$slice$split = name.slice(1).split('/'), _name$slice$split2 = _toArray(_name$slice$split), namespace = _name$slice$split2[0], hash = _name$slice$split2[1], remainder = _name$slice$split2.slice(2);
              _context2.prev = 7;
              new CID(hash); // eslint-disable-line no-new

              _context2.next = 19;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](7);

              if (!isDomain(hash)) {
                _context2.next = 17;
                break;
              }

              _context2.next = 16;
              return appendRemainder(dns(hash, options), remainder);

            case 16:
              return _context2.abrupt("return");

            case 17:
              log.error(_context2.t0);
              throw errcode(new Error('Invalid IPNS name'), 'ERR_IPNS_INVALID_NAME');

            case 19:
              if (!(!isOnline() && !offline)) {
                _context2.next = 21;
                break;
              }

              throw errcode(new Error(OFFLINE_ERROR), 'OFFLINE_ERROR');

            case 21:
              _context2.next = 23;
              return appendRemainder(ipns.resolve("/".concat(namespace, "/").concat(hash), options), remainder);

            case 23:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[7, 11]]);
    }));

    function resolve(_x, _x2) {
      return _resolve.apply(this, arguments);
    }

    return resolve;
  }());
};